module.exports = __webpack_public_path__ + "media/assets/images/authors/dario_menin-1b0645471e3727fd9ad6a39dad2bc409.jpg";